var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0255 13.9486C30.007 13.9482 29.9886 13.9482 29.9702 13.9484C29.128 13.9576 28.3252 14.354 27.7462 15.0468C27.167 15.7398 26.8615 16.6696 26.8997 17.6228L27.7192 37.345C27.8558 40.6323 32.1458 40.6321 32.2822 37.3448L33.1002 17.6269C33.139 16.6579 32.8254 15.7175 32.2333 15.0225C31.677 14.3695 30.9197 13.986 30.1202 13.9509L30.0651 13.9492L30.0255 13.9486Z",
    fill: "url(#paint0_linear_113_306)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9999 49.1207C28.2859 49.1207 26.8965 47.7312 26.8965 46.0172C26.8965 44.3032 28.2859 42.9138 29.9999 42.9138C31.7139 42.9138 33.1034 44.3032 33.1034 46.0172C33.1034 47.7312 31.7139 49.1207 29.9999 49.1207Z",
    fill: "url(#paint1_linear_113_306)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.10352 32.8276C3.10352 17.8302 15.2613 5.67241 30.2587 5.67241C37.4607 5.67241 44.3677 8.5334 49.4603 13.626C54.5529 18.7186 57.4139 25.6256 57.4139 32.8276C57.4139 47.825 45.2561 59.9828 30.2587 59.9828C15.2613 59.9828 3.10352 47.825 3.10352 32.8276ZM46.26 16.8262C42.0161 12.5824 36.2603 10.1983 30.2586 10.1983C17.7608 10.1983 7.62931 20.3298 7.62931 32.8276C7.62931 45.3254 17.7608 55.4569 30.2586 55.4569C42.7564 55.4569 52.8879 45.3254 52.8879 32.8276C52.8879 26.8259 50.5038 21.0701 46.26 16.8262Z",
    fill: "url(#paint2_linear_113_306)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_113_306",
    x1: 34.6551,
    y1: 39.8103,
    x2: 19.1379,
    y2: 14.9828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6BB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93C51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_113_306",
    x1: 34.6551,
    y1: 49.1207,
    x2: 33.4395,
    y2: 41.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6BB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93C51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_113_306",
    x1: 30.0001,
    y1: 5.67241,
    x2: 30.2587,
    y2: 59.9828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6BB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93C51"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.a48c179de92d2ca3d63a31e9be65ab03.svg";
export { ForwardRef as ReactComponent };